<template lang="pug">
  div
    SingleNumWrapper(
      :chartType="'servedsumnum'"
      :chartTitle="$t('dashboard.dataServedUsage')"
      :numeralFormat="'0.0b'"
      :maxFontSize="'42px'"
      :withCard="withCard"
    )
    LineChartWrapper(
      :chartType="'cacheStatusLineChart'"
      :chartDataSetLabel="[$t('dashboard.dataCachedUsage'), $t('dashboard.dataServedUsage')]"
      :titleDisplay="false"
      :numeralFormat="'0.00b'"
      :withCard="withCard"
      :chartWidth="600"
      :chartHeight="100"
      :xAxesDisplay="false"
      :yAxesDisplay="false"
      :legendDisplay="false"
      :lineBorderColors="[colorScheme.green.border, colorScheme.blue.border]"
      :lineBackgroundColors="[colorScheme.green.fillTransparent, colorScheme.blue.fillTransparent]"
      :linePointRadius="[0, 0]"
      :withPropRawBtn="false"
      )
</template>
<script>
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";

import colorScheme from "@/data/colorScheme";

export default {
    components: {
        SingleNumWrapper,
        LineChartWrapper
    },
    props: {
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        withCard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            colorScheme: colorScheme
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage/DataUsageCard.vue